<div class="filter-main-container">
  <div class="header">
    <h3>Edit Filters</h3>
    <div class="button-container" fxLayout="row">
      <button mat-button color="primary" type="submit" class="text-uppercase" (click)="onApply()">
        <mat-icon>check</mat-icon> Apply
      </button>
      <button type="button" class="text-uppercase" type="reset" mat-button (click)="cancel.emit()">
        <mat-icon>close</mat-icon> Cancel
      </button>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="filter-content">
    <ng-scrollbar>
      <div class="filters">
        <div class="view-contect" fxLayout="column">
          <div cdkDropList cdkDropListLockAxis="y" (cdkDropListDropped)="onValueListItemDropped($event)">
            <div cdkDrag *ngFor="let item of manageFilterItems">
              <mat-card class="filter-card">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                  <div fxLayout="row" fxLayoutAlign="start center">
                    <ng-content select="[slot=drag-handle]"></ng-content>
                    <mat-icon slot="drag-handle" cdkDragHandle>drag_indicator</mat-icon>
                    <div class="filter-name" [matTooltip]="item.name" matTooltipShowDelay="500">{{ item.name }}</div>
                  </div>
                  <button
                    mat-icon-button
                    color="primary"
                    [disabled]="manageFilterItems.length < 2"
                    (click)="onDeleteFilter(item)"
                    aria-label="Remove from quick filter"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </mat-card>
            </div>
          </div>
        </div>
        <item-picker
          [data]="itemPickerList"
          placeholder="ADD FILTER"
          type="button"
          (select)="onAddFilter($event)"
        ></item-picker>
      </div>
    </ng-scrollbar>
  </div>
</div>
